<template>
    <div class="dia_container">
        <div class="">
            <div class="form_line cl">
                <label class="l">手机号码<span class="red">*</span>：</label>
                <div class="l ml10"><el-input v-model="mobile"></el-input></div>
            </div>
            <div class="form_line cl">
                <label class="l">姓名<span class="red">*</span>：</label>
                <div class="l ml10"><el-input v-model="userName"></el-input></div>
            </div>
            <div class="form_line cl">
                <label class="l">邮箱<span class="red">*</span>：</label>
                <div class="l ml10"><el-input v-model="email"></el-input></div>
            </div>
        </div>
        <div class="dia_btn_container">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="save">确定</el-button>
        </div>
    </div>
</template>
<script>
    import { errorMessage } from '../../../util'
    export default {
        props: ['param'],
        data() {
            return {
                mobile: '',
                userName: '',
                email: ''
            }
        },
        methods: {
            // 保存初始密码
            save() {
                let result = this.verify()
                if(result) {
                    this.$message.warning(result)
                    return
                }
                this.$http.post(`/platserv/tenantAccount/generateAdminAccount`,{
                    mobile: this.mobile,
                    username: this.userName,
                    email: this.email,
                    tenantcode: this.param.tenantCode,
                    productcode: this.param.productCode,
                    productversioncode: this.param.productVersionCode
                }).then(function(res){
                    this.$message.success('生成管理员账号成功！')
                    this.cancel()
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            cancel() {
                this.$emit('cancel')
            },
            verify() {
                let ret = false
                if(!this.mobile) {
                    ret = '请填写手机号！'
                } else if(!this.userName) {
                    ret = '请填写姓名！'
                } else if(!this.email) {
                    ret = '请填写邮箱！'
                }
                return ret
            }
        }
    }
</script>


// WEBPACK FOOTER //
// GenerateAccount.vue?61542280